import { AdditiveBlending, Group, Mesh, MeshBasicMaterial, PlaneGeometry, type Texture } from 'three'
import type { CharacterVisualState } from './SceneBridge'

/**
 * "This one is you", for a player among up to six fighters online — two of
 * them possibly the same fighter in different colours.
 *
 * A pool of white light under the feet, wider than the slot's own glow and
 * slowly breathing. Not a marker over the head (asked for explicitly), and not
 * a ring or a sector: those shapes belong to the moves, and a mark that looked
 * like a Wave going off under your own feet would be worse than none.
 */
export class OwnMarker {
  readonly group = new Group()
  private readonly pool: Mesh
  private clock = 0

  constructor(glow: Texture) {
    this.pool = new Mesh(
      new PlaneGeometry(3.8, 3.8),
      new MeshBasicMaterial({
        map: glow,
        color: 0xffffff,
        transparent: true,
        opacity: 0,
        blending: AdditiveBlending,
        depthWrite: false,
        toneMapped: false,
      }),
    )
    this.pool.rotation.x = -Math.PI / 2
    // Under the slot glow (0.03), so the colour still reads on top of it.
    this.pool.position.y = 0.02
    this.group.add(this.pool)
    this.group.visible = false
  }

  update(state: CharacterVisualState, dt: number): void {
    this.group.visible = state.own
    if (!state.own) return
    this.clock += dt
    const breath = 0.5 + 0.5 * Math.sin(this.clock * Math.PI * 1.4)
    ;(this.pool.material as MeshBasicMaterial).opacity = 0.34 + 0.14 * breath
  }

  dispose(): void {
    this.pool.geometry.dispose()
    ;(this.pool.material as MeshBasicMaterial).dispose()
  }
}
